import {
  iSharedCartFlightSearch,
  iSharedCartFlightSegment,
  iSharedCartHotelSearch,
  iSharedCartPayload,
  iSharedCartSearch,
} from "../../api/sharedCart/sharedCart";
import { handleFlightClass } from "../booking/flight/handleFlightClass";

const day = (value: unknown): string => (typeof value === "string" ? value.slice(0, 10) : "");

const text = (value: unknown): string => (value === null || value === undefined ? "" : String(value));

const hotelSearchFromDetails = (hotels: any[]): iSharedCartHotelSearch | undefined => {
  const stays = hotels.map((hotel) => {
    const details = hotel?.hotelDetails?.data ?? {};
    return {
      city: text(hotel?.city),
      country: text(details.country).toUpperCase(),
      latitude: text(details.latitude),
      longitude: text(details.longitude),
      checkIn: day(hotel?.checkIn),
      checkOut: day(hotel?.checkOut),
    };
  });
  return stays.length && stays.every((stay) => stay.city && stay.checkIn && stay.checkOut) ? { stays, rooms: [] } : undefined;
};

const legSegment = (first: any, last: any): iSharedCartFlightSegment => {
  const firstSegments: any[] = Array.isArray(first?.segments) ? first.segments : [];
  const lastSegments: any[] = Array.isArray(last?.segments) ? last.segments : [];
  return {
    departure: text(firstSegments[0]?.depAirportCode),
    arrival: text(lastSegments[lastSegments.length - 1]?.arrAirportCode),
    departureDate: day(firstSegments[0]?.departureDate),
  };
};

const flightSearchFromDetails = (details: any): iSharedCartFlightSearch | undefined => {
  const outbound: any[] = Array.isArray(details?.outbound) ? details.outbound : [];
  const inbound: any[] = Array.isArray(details?.inbound) ? details.inbound : [];
  if (!outbound.length) return undefined;
  const tripType: iSharedCartFlightSearch["tripType"] =
    details.tripType === 1 || details.tripType === 2 || details.tripType === 3 ? details.tripType : inbound.length ? 2 : 1;
  const segments =
    tripType === 3
      ? outbound.map((leg) => legSegment(leg, leg))
      : [
          {
            ...legSegment(outbound[0], outbound[outbound.length - 1]),
            ...(tripType === 2 ? { returnDate: day(inbound[0]?.segments?.[0]?.departureDate) } : {}),
          },
        ];
  const complete =
    segments.every((segment) => segment.departure && segment.arrival && segment.departureDate) &&
    (tripType !== 2 || !!segments[0].returnDate);
  return complete
    ? {
        tripType,
        cabin: handleFlightClass(text(details.cabinClass) || "economy") as iSharedCartFlightSearch["cabin"],
        adults: typeof details.adults === "number" ? details.adults : 1,
        children: typeof details.children === "number" ? details.children : 0,
        infants: typeof details.infants === "number" ? details.infants : 0,
        segments,
      }
    : undefined;
};

export const sharedCartFallbackSearch = (
  snapshot: iSharedCartPayload | undefined,
  details: any
): iSharedCartSearch | undefined => {
  const hotels: any[] = Array.isArray(details?.hotels) ? details.hotels : [];
  const hotel = snapshot?.search?.hotel ?? (hotels.length ? hotelSearchFromDetails(hotels) : undefined);
  const flight = snapshot?.search?.flight ?? (details?.flight?.details ? flightSearchFromDetails(details.flight.details) : undefined);
  if (!hotel && !flight) return undefined;
  return { ...(hotel ? { hotel } : {}), ...(flight ? { flight } : {}) };
};
